import { injectable } from 'inversify';
import { FormatErrorSeverity } from '@Models';
import { formater_error } from '@Api';

@injectable()
export class FormatErrorSeverityMapper {
  public map(item: formater_error.severity): FormatErrorSeverity {
    switch (item) {
      case formater_error.severity.WARNING:
        return FormatErrorSeverity.WARNING;
      case formater_error.severity.INFO:
        return FormatErrorSeverity.INFO;
    }
    return FormatErrorSeverity.ERROR;
  }
}
